import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const suffixAsterisk = text => /*#__PURE__*/_jsxs(_Fragment, {
  children: [text, " ", /*#__PURE__*/_jsx("span", {
    "aria-hidden": true,
    children: "*"
  })]
});
export const getItemsInText = text => {
  if (!text) return [];
  return text.split(/[,|;| |\n]+/).filter(Boolean);
};